import { createContext } from 'react';
import { SwiperClass } from 'swiper/react';

import { DeviceInformation } from '../../../hooks/use-element';
import { ArticleRelevance } from '../../../utils/ArticleRelevance';
import { ScrollDirection } from '../../../components/article/Article.context';
import { NavbarVisibility } from '../../../constants';
import { TrackingEvent } from '../../../tracking/Tracking.events';
export const ResponsiveContext = createContext<ResponsiveContextProps>({
	swiper: null,
	setSwiper: () => {},
	isMenuOpen: false,
	device: null,
	setIsMenuOpen: () => {},
	isSidebarOpen: true,
	setIsSidebarOpen: () => {},
	toggleSidebar: () => {},
	toggleMenu: () => {},
	onTransitionEnd: () => {},
	onNextArticleClick: () => {},
	onPrevArticleClick: () => {},
	index: null,
	setIndex: () => {},
	total: 0,
	search: '',
	setSearch: () => {},
	articleIndexMap: new Map(),
	navbarVisibility: 'visible',
	setNavbarVisibility: () => {},
	sendEvent: () => {},
	isProfileMenuOpen: false,
	setIsProfileMenuOpen: () => {},
});

interface ResponsiveContextProps {
	swiper: SwiperClass | null;
	setSwiper: (s: SwiperClass) => void;
	isMenuOpen: boolean;
	setIsMenuOpen: Function;
	isSidebarOpen: boolean;
	device: DeviceInformation | null;
	setIsSidebarOpen: Function;
	toggleSidebar: Function;
	toggleMenu: Function;
	onTransitionEnd: (s: SwiperClass) => void;
	onNextArticleClick: Function;
	onPrevArticleClick: Function;
	index: number | null;
	setIndex: Function;
	total: number;
	search: string;
	setSearch: Function;
	articleRelevance?: ArticleRelevance;
	setScrollDirection?: (direction: ScrollDirection) => void;
	scrollDirection?: 'up' | 'down' | undefined;
	articleIndexMap: Map<string, number>;
	navbarVisibility: NavbarVisibility;
	setNavbarVisibility: Function;
	sendEvent: (event: TrackingEvent) => void;
	isProfileMenuOpen: boolean;
	setIsProfileMenuOpen: (v: boolean) => void;
}
